import { APP_SETTINGS } from "../../config";
import axios from "axios";

function filterTaskByMilesoneApi(projectId, token) {
  // console.log('inside api hittt');
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.kanbanFilterTaskByProject,
    projectId
    // {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // }
  );
}

function fetchProjectMilestones(projectId, token) {
  // console.log('inside api hittt');
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.getMilestonesByProject,
    projectId
    // {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // }
  );
}

function createProjectMilestone(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.addProjectMilestone,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

function CreateTaskInMilestone(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.createTaskInMilestone,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

function FetchTaskInMilestone(milestoneId, token) {
  var url = `${APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.fetchTaskInMilestone}?milestoneId=${milestoneId}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

function fetchMilestonesTask(data, token) {
  // console.log('inside api hittt');
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.fetchTaskInMilestone,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

function startSprintApi(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.startSprint,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

function completeSprintIfTasksCompletedActionApi(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE
      .completeSprintIfTasksCompleted,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
function getAllSprintsWithoutStartSprintApi(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE
      .getAllSprintsWithoutStartSprint,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
function moveSprintTasksApi(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.moveSprintTasks,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
function userSelectedMileStoneApi(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTMILESTONE.userSelectedMileStone,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export {
  fetchProjectMilestones,
  createProjectMilestone,
  CreateTaskInMilestone,
  FetchTaskInMilestone,
  fetchMilestonesTask,
  startSprintApi,
  completeSprintIfTasksCompletedActionApi,
  getAllSprintsWithoutStartSprintApi,
  moveSprintTasksApi,
  userSelectedMileStoneApi,
  filterTaskByMilesoneApi,
};
